// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';


const firebaseConfig = {
  apiKey: "AIzaSyAg9pk2FsX-jt5S3lmr2gNSNb3QIFxdOI4",
  authDomain: "flermotest.firebaseapp.com",
  projectId: "flermotest",
  storageBucket: "flermotest.appspot.com", // corrected the domain
  messagingSenderId: "517804407646",
  appId: "1:517804407646:web:281614cafa903ad96fedcf",
  measurementId: "G-5ME0976QMB",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);